import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';

import { ISvcChipOption, SvcControlsModule } from '@solvace/component/svc-controls';
import { SvcDialogMode } from '@solvace/component/svc-dialogs';
import { SvcSmartUserAvatarModule } from '@solvace/feature/general/svc-smart-user-avatar';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';

@Component({
  selector: 'svc-action-plan-approval-tab',
  standalone: true,
  imports: [
    CommonModule,
    LibSharedCommonModule,
    ReactiveFormsModule,
    TranslocoModule,
    SvcControlsModule,
    SvcSmartUserAvatarModule,
  ],
  templateUrl: './svc-action-plan-approval-tab.component.html',
  styleUrls: ['./svc-action-plan-approval-tab.component.scss'],
})
export class SvcActionPlanApprovalTabComponent {
  public readonly mode = input<SvcDialogMode>(SvcDialogMode.add);
  public readonly approverControl = input<FormControl>(new FormControl([]));
  public readonly usersOptions = input<ISvcChipOption[]>([]);
  public readonly isLoading = input<boolean>(false);
  public readonly selectedApproverIds = input<string[]>([]);
  public readonly selectedApproverLabels = input<string[]>([]);
  // Whether the multi-select chip is editable. The parent composes the rule
  // (add/edit mode AND `canModifyApprover` from the permission service) so the
  // tab stays a dumb renderer. When false the tab always renders the
  // read-only display, even if the modal is technically in edit mode.
  public readonly canEdit = input<boolean>(false);

  public readonly approverIdsChange = output<string[]>();

  public get isAddMode(): boolean {
    return this.mode() === SvcDialogMode.add;
  }

  public get isEditMode(): boolean {
    return this.mode() === SvcDialogMode.edit;
  }
}
